module.exports = __webpack_public_path__ + "static/img/ban.d375ff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/JoinUs/img/ban.jpg
// module id = rSGW
// module chunks = 1